module.exports = __webpack_public_path__ + "img/insta.77724438.svg";